module.exports = __webpack_public_path__ + "static/media/beer2_clean_cropped.42ca2890.png";